import React from "react";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";

export const SidenavRoot = styled(Drawer)(({ theme, ownerState }) => {
  const { palette, transitions, breakpoints } = theme;
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode } = ownerState;

  const sidebarWidth = 250;
  const collapsedWidth = 60;

  // Sidenav background color based on theme
  let backgroundValue = darkMode
    ? palette.grey[900]
    : palette.grey[800];

  if (transparentSidenav && !miniSidenav) {
    backgroundValue = 'transparent';
  } else if (whiteSidenav) {
    backgroundValue = palette.common.white;
  }

  return {
    width: miniSidenav ? collapsedWidth : sidebarWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    "& .MuiDrawer-paper": {
      backgroundColor: backgroundValue,
      boxShadow: transparentSidenav && !miniSidenav ? "none" : theme.shadows[8],
      borderRight: transparentSidenav && !miniSidenav ? "none" : `1px solid ${theme.palette.divider}`,
      width: miniSidenav ? collapsedWidth : sidebarWidth,
      transition: transitions.create(["width", "margin"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
      overflowX: "hidden",
      [breakpoints.up("xl")]: {
        width: miniSidenav ? collapsedWidth : sidebarWidth,
      },
      [breakpoints.down("xl")]: {
        width: miniSidenav ? 0 : sidebarWidth,
        left: 0,
        top: 0,
        borderRight: miniSidenav ? "none" : `1px solid ${theme.palette.divider}`,
        boxShadow: miniSidenav ? "none" : theme.shadows[8],
      },
      "& .MuiListItemIcon-root": {
        minWidth: miniSidenav ? 36 : 48,
        transition: transitions.create(["min-width", "margin"], {
          easing: transitions.easing.easeInOut,
          duration: transitions.duration.standard,
        }),
        marginRight: miniSidenav ? 0 : 8,
      },
      "& .MuiListItemText-root": {
        opacity: miniSidenav ? 0 : 1,
        transition: transitions.create(["opacity", "margin"], {
          easing: transitions.easing.easeInOut,
          duration: transitions.duration.standard,
        }),
      },
      "& .MuiCollapse-root .MuiList-root": {
        padding: miniSidenav ? 4 : 8,
        transition: transitions.create("padding", {
          easing: transitions.easing.easeInOut,
          duration: transitions.duration.standard,
        }),
      },
      "& .MuiDivider-root": {
        margin: miniSidenav ? "4px 0" : "8px 0",
        transition: transitions.create("margin", {
          easing: transitions.easing.easeInOut,
          duration: transitions.duration.standard,
        }),
      },
      "& .MuiBox-root": {
        "& img": {
          transition: transitions.create(["width", "height"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      },
      // Style for menu expand/collapse arrows
      "& .MuiAccordionSummary-expandIconWrapper, & .MuiListItem-root .MuiSvgIcon-root": {
        color: palette.common.white + " !important",
      },
    },
  };
});

export default SidenavRoot;
